import Vue from "vue";
import moment from "moment";

// URL Default de acesso ao sistema de recurso da aplicação

export const baseApiUrl = process.env.VUE_APP_API_URL;

export const sexo = [
  { name: "Masculino", code: "M" },
  { name: "Feminino", code: "F" },
];

export const simNao = [
  { name: "Não", code: "N" },
  { name: "Sim", code: "S" },
];

export const money = {
  decimal: ",",
  thousands: ".",
  prefix: "R$ ",
  suffix: "",
  precision: 2,
  masked: false,
};

export const paginasChefia = [
  "gerenciaRelatorios",
  "gerenciaValidacao",
  "cadastroExercicio",
  "cadastroUsuario",
  "cadastroPerfilUsuario",
];

export const perfisAdm = [
  {
    perfil: "DECLA_GERAL",
    permissoes: [
      "formDeclaracaoBens",
      "formDeclaracaoBensEdit",
      "formDeclaracaoBensVisualizar",
    ],
  },
  {
    perfil: "DECLA_ADMIN_SETORIAL",
    permissoes: [
      "gerenciaRelatorios",
      "RH",
      "gerenciaValidacao",
      "relatorio",
      "relatorioConsolidado",
      "retificacao",
    ],
  },
  {
    perfil: "DECLA_ADMIN_CENTRAL",
    permissoes: [
      "gerenciaRelatorios",
      "seguranca",
      "cadastroExercicio",
      "cadastroUsuario",
      "atribuirAcessoFiscal",
      // 'cadastroPerfilUsuario',
      "retificacao",
      "RH",
      "gerenciaValidacao",
      "relatorio",
      "relatorioConsolidado",
      "auditoria",
    ],
  },
  {
    perfil: "DECLA_FISCAL",
    permissoes: ["fiscalizacao"],
  },
];

export const perfis = [
  {
    perfil: "RECADRL_CHEFIA",
    permissoes: [],
  },
];

// Tratamento de erro geral das telas
Vue.config.errorHandler = function(err, vm, info) {
  // trata a mensagem para ser exibida ao usuário)
  exibirErroTratado(err, vm, "error", info);
};

export function exibirErroTratado(error, vm, severity, info) {
  // Cria as variavel de mensagem ao usuário
  let msgUsuario = "";
  // Verifica mensagem retornada
  if (error && error.response && error.response.data) {
    if (
      Array.isArray(error.response.data) &&
      error.response.data[0].msgUsuario
    ) {
      msgUsuario = error.response.data[0].msgUsuario;
    } else {
      msgUsuario = error.response.data;
    }
  } else if (typeof error === "string") {
    msgUsuario = error;
  } else {
    msgUsuario = info;
  }
  if (typeof msgUsuario != "object") {
    Vue.prototype.$toast.add({ severity, summary: msgUsuario, life: 15000 });
  }
}

Vue.config.warnHandler = function(msg, vm) {
  exibirErroTratado(
    msg,
    vm.parent,
    "warn",
    "Um alerta na operação do sistema foi gerado"
  );
};

export function languagePtBr() {
  return {
    firstDayOfWeek: 0,
    dayNames: [
      "Domingo",
      "Segunda",
      "Terça",
      "Quarta",
      "Quinta",
      "Sexta",
      "Sábado",
    ],
    dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
    dayNamesMin: ["Do", "Se", "Te", "Qa", "Qi", "Sx", "Sa"],
    monthNames: [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro",
    ],
    monthNamesShort: [
      "Jan",
      "Fev",
      "Mar",
      "Abr",
      "Mai",
      "Jun",
      "Jul",
      "Ago",
      "Set",
      "Out",
      "Nov",
      "Dez",
    ],
    today: "Hoje",
    clear: "Limpar",
    dateFormat: "dd/mm/yy",
    weekHeader: "Sm",
  };
}

export function isDate(data) {
  return data instanceof Date && !isNaN(data.valueOf());
}

export function strToDate(objeto, campos) {
  // Percorre a array de campos
  for (var i = 0; i < campos.length; i++) {
    // Verifcia se é a propriedade display format
    if (campos[i].displayFormat) {
      // carrega o objeto campo
      var campo = campos[i];
      // Converte a string para o formato data
      objeto[campo] = moment(objeto[campo], campo.displayFormat).toDate();
    }
  }
}

export function dateToStr(objeto, campos) {
  // Percorre a array de campos
  for (var i = 0; i < campos.length; i++) {
    // Verifcia se é a propriedade display format
    if (campos[i].displayFormat) {
      // carrega o objeto campo
      var campo = campos[i];
      // Converte a string para o formato data
      objeto[campo.nome] = moment(objeto[campo.nome]).format(
        campo.displayFormat
      );
    }
  }
}

export function printToast({ severity, summary, detail = "" }) {
  let maiorMessage = summary.length > detail.length ? summary : detail;
  let messageLength = maiorMessage.split(" ").length;
  let life = (messageLength * 60000) / 150;
  Vue.prototype.$toast.add({ severity, summary, detail, life });
}

export async function getVersaoFront() {
  let versao = await Vue.prototype.$http.get(
    `${baseApiUrl}/publicos/sdb/frontend/versao`
  );

  if (versao.status == 200) {
    // let LocalStorageSeplag = localStorage.getItem(process.env.VUE_APP_USER_KEY)
    let dataToken;
    if (localStorage.getItem(process.env.VUE_APP_USER_KEY)) {
      let dadosStorageSeplagJson = decodeURI(
        atob(localStorage.getItem(process.env.VUE_APP_USER_KEY))
      );
      dataToken = JSON.parse(dadosStorageSeplagJson);
    }

    let storageSeplagJson = dataToken;

    let { versaoFront } = storageSeplagJson[process.env.VUE_APP_NOME_SISTEMA];
    let versaoAtual = versaoFront ? versaoFront : null;

    if (!versaoAtual || versaoAtual != versao.data) {
      storageSeplagJson[process.env.VUE_APP_NOME_SISTEMA].versaoFront =
        versao.data;

      localStorage.setItem(
        process.env.VUE_APP_USER_KEY,
        btoa(JSON.stringify(storageSeplagJson))
      );

      window.location.reload();
    }

    return versaoAtual;
  }
}

export default {
  baseApiUrl,
  sexo,
  simNao,
  money,
  perfis,
  perfisAdm,
  paginasChefia,
  languagePtBr,
  isDate,
  strToDate,
  dateToStr,
  exibirErroTratado,
  getVersaoFront,
};
